import {NgModule} from '@angular/core';
import {FormDefinitionGroupConverter} from "./api/entity/converter/formDefinitionGroup.converter";
import {FormDefinitionGroupFieldConverter} from "./api/entity/converter/formDefinitionGroupField.converter";

@NgModule({
    providers: [
        FormDefinitionGroupConverter,
        FormDefinitionGroupFieldConverter,
    ]
})
export class FormDefinitionGroupModule {
}
